<header>
    <h1>{{ 'pages.exports.title' | translate }}</h1>
</header>

<section class="wrapper">
    <h3>{{ 'pages.exports.receipts' | translate }}</h3>

    <form class="controls" [formGroup]="receiptsForm">
        <div class="row">
            <app-form-datepicker
                formControlName="startDate"
                [label]="'pages.exports.form.startDate' | translate"
                [placeholder]="'pages.exports.form.endDate' | translate"
            ></app-form-datepicker>
            <app-form-datepicker
                formControlName="endDate"
                [label]="'pages.exports.form.endDate' | translate"
                [placeholder]="'pages.exports.form.endDate' | translate"
            ></app-form-datepicker>
        </div>
        <div class="row">
            <button class="bciti-button bciti-button--blue" (click)="getReceipts()">
                <span *ngIf="!receiptsLoading">{{ 'pages.exports.form.search' | translate }}</span>
                <mat-progress-spinner *ngIf="receiptsLoading" mode="indeterminate" diameter="20"></mat-progress-spinner>
            </button>
            <button class="bciti-button bciti-button--blue" (click)="downloadReceiptsAsCSV()">
                <span *ngIf="!receiptsDownloadLoading"><span class="icon-desktop-monitor-download"></span> &nbsp; .CSV</span>
                <mat-progress-spinner *ngIf="receiptsDownloadLoading" mode="indeterminate" diameter="20"></mat-progress-spinner>
            </button>
        </div>
    </form>

    <mat-table [dataSource]="receiptsDataSource" matSort>
        <ng-container matColumnDef="transactionNumber">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'pages.exports.table.headers.transactionNumber' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.transactionNumber }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="receiptNumber">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'pages.exports.table.headers.receiptNumber' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.receiptNumber }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'pages.exports.table.headers.date' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.date }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="cardType">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'pages.exports.table.headers.cardType' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.cardType }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="cardNumber">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'pages.exports.table.headers.cardLastFourDigits' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ getLastFourCharacters(element?.cardNumber) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="transactionSuccess">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'pages.exports.table.headers.transactionSuccess' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element">
                <span *ngIf="element.transactionSuccess" class="green icon-check-circle"></span>
                <span *ngIf="!element.transactionSuccess" class="red icon-close-circle"></span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="transactionType">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'pages.exports.table.headers.transactionType' | translate }}</mat-header-cell>
            <mat-cell class="left" *matCellDef="let element">{{ element?.transactionType }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="total">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'pages.exports.table.headers.total' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.total }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="code">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'pages.exports.table.headers.code' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.code }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'pages.exports.table.headers.name' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ getUserName(element) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="phone">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'pages.exports.table.headers.phone' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element?.phone }}</mat-cell>
        </ng-container>

        <div class="mat-row" *matNoDataRow>
            <div class="mat-cell no-data">
                <span *ngIf="receiptsHasSearchedOnce">{{ 'pages.exports.table.noData' | translate }}</span>
                <span *ngIf="!receiptsHasSearchedOnce">{{ 'pages.exports.table.getStarted' | translate }}</span>
            </div>
        </div>

        <mat-header-row *matHeaderRowDef="receiptsTableColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: receiptsTableColumns"></mat-row>
    </mat-table>
</section>